export default __webpack_public_path__ + "static/media/135.e079005d.jpg";